import { unwrapResult } from '@reduxjs/toolkit'
import { Route } from '../../../config/router'
import { Checkout } from '@afterpaytouch/portal-api/types'
import { ConsumerAccountResponse, CrossRegionRedirection } from '../../../model'
import { AsyncAction, accountLookup, checkPersistentLogin, CheckoutAppDispatch } from '../../../state'
import { determinePersistentLoginRoute, InitialiseNextRoute } from '../routing'

type LoadPersistentConsumerResult = ConsumerAccountResponse | Route.VERIFY | null

const isConsumerAccountResponse = (loadPersistentConsumerResult: LoadPersistentConsumerResult): loadPersistentConsumerResult is ConsumerAccountResponse => {
  return loadPersistentConsumerResult !== null && loadPersistentConsumerResult !== Route.VERIFY
}

const loadPersistentConsumer = (): AsyncAction<LoadPersistentConsumerResult> => async (dispatch) => {
  try {
    const { active, verify } = unwrapResult(await dispatch(checkPersistentLogin()))
    if (active && verify) {
      return Route.VERIFY
    }
    if (active) {
      return unwrapResult(await dispatch(accountLookup()))
    }
  } catch (e) {
    // Intentionally swallow errors as we return null to indicate no persistent login
  }
  return null
}

export const handlePersistentLogin = async (
  checkout: Checkout,
  dispatch: CheckoutAppDispatch
): Promise<InitialiseNextRoute | CrossRegionRedirection | { route: Route } | null> => {
  const account = await dispatch(loadPersistentConsumer())

  if (account !== null) {
    // Persistent logged-in user
    if (isConsumerAccountResponse(account)) {
      return await determinePersistentLoginRoute({ account, checkout }, dispatch)
    } else {
      // trusted checkout 2fa
      return { route: account as Route.VERIFY }
    }
  }

  return null
}
